import {
  reportsCampaignsPath,
  reportsDashboardPath,
  reportsDataSearchPath,
  reportsJaqiAiPath,
} from 'app/navigation/paths'

export interface Page {
  name: string
  path: string
}
export const PATH: Record<string, string> = {
  Dashboard: reportsDashboardPath,
  Campaigns: reportsCampaignsPath,
  DataSearch: reportsDataSearchPath,
  JaqiAi: reportsJaqiAiPath,
}

export const PAGES: Page[] = [
  {
    name: 'Live Dashboard',
    path: PATH.Dashboard,
  },
  {
    name: 'Campaigns',
    path: PATH.Campaigns,
  },
  {
    name: 'Data Search',
    path: PATH.DataSearch,
  },
  {
    name: 'Jaqi AI',
    path: PATH.JaqiAi,
  },
]

export const DASHBOARD_NAV_ITEMS = [
  { key: 'accounts', title: 'Account Overview', path: PATH.Dashboard },
  { key: 'campaigns', title: 'Campaign Overview', path: PATH.Campaigns },
  { key: 'data-search', title: 'Data Search', path: PATH.DataSearch },
  { key: 'jaqi', title: 'Jaqi', path: PATH.JaqiAi },
] as const
